(function () {
  let trackingInProgress = false;
  
  function trackCollectionView() {
    // Prevent multiple simultaneous executions
    if (trackingInProgress) return;
    
    // Check if we're on a collection page
    if (!window.location.pathname.includes('/collections/')) {
      return;
    }
    
    if (document.body.dataset.collectionTracked) {
      return;
    }
    
    trackingInProgress = true;
    
    // Get collection data from collection header
    const collectionHeader = document.querySelector('.collection-header-title');
    
    if (!collectionHeader) {
      trackingInProgress = false;
      return;
    }

    const itemListName = collectionHeader.textContent.trim();
    const itemListId = collectionHeader.getAttribute('collection-id');
    const collectionItems = document.querySelectorAll('[data-product-id], .product-card, .product-item, .collection-listing__item').length;

    if (!itemListName || !itemListId) {
      trackingInProgress = false;
      return;
    }

    if (typeof gtag === 'undefined') {
      trackingInProgress = false;
      return;
    }

    gtag('event', 'view_item_list', {
      item_list_name: itemListName,
      item_list_id: itemListId,
      collection_items: collectionItems
    });

    // Mark as tracked to prevent duplicate events
    document.body.dataset.collectionTracked = 'true';
    trackingInProgress = false;
  }

  function bindCartDrawerClick() {
    document.querySelectorAll('open-cart-drawer').forEach(element => {
      if (element.dataset.gaBound) return;
      element.dataset.gaBound = 'true';

      element.addEventListener('click', () => {
        if (typeof gtag !== 'undefined') {
          // Get cart items titles
          const cartItemEls = document.querySelectorAll('.cart-item-title');
          const cartItems = Array.from(cartItemEls).map(el => el.textContent.trim()).filter(Boolean);

          // Try to get cart total from common selectors
          let cartTotal = '';
          const totalEl = document.querySelector('.cart-checkout-total');
          if (totalEl) {
            cartTotal = totalEl.textContent.trim();
          }

          gtag('event', 'view_cart', {
            cart_items: cartItems,
            cart_total: cartTotal
          });
        }
      });
    });
  }

  function bindProductCardClick() {
    // Only bind on collection pages
    if (!window.location.pathname.includes('/collections/')) return;

    document.querySelectorAll('.product-card').forEach(card => {
      if (card.dataset.gaBound) return;
      card.dataset.gaBound = 'true';

      card.addEventListener('click', () => {
        const collectionHeader = document.querySelector('.collection-header-title');
        const collectionName = collectionHeader ? collectionHeader.textContent.trim() : '';
        const productTitleEl = card.querySelector('.product-title');
        const productTitle = productTitleEl ? productTitleEl.textContent.trim() : '';

        if (typeof gtag !== 'undefined') {
          gtag('event', 'select_item', {
            collection: collectionName,
            product_title: productTitle
          });
        }
      });
    });
  }

  function bindAll() {
    bindCartDrawerClick();
    bindProductCardClick();
  }

  // Track collection view on initial load
  setTimeout(trackCollectionView, 1000);
  
  // Bind events initially and on DOM changes
  bindAll();
  
  // Only observe for a short period to catch dynamic content
  const observer = new MutationObserver(() => {
    if (!document.body.dataset.collectionTracked) {
      trackCollectionView();
    }
    bindAll();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Stop observing after 10 seconds to prevent infinite loops
  setTimeout(() => {
    observer.disconnect();
  }, 10000);
})();
